import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-freight-rate-set-create',
  templateUrl: './freight-rate-set-create.component.html',
  styleUrls: ['./freight-rate-set-create.component.css']
})
export class FreightRateSetCreateComponent implements OnInit {
    custNo;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public creating = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.custNo = this.stateService.getStateParams()['cust_no'];
    }

    private async loadEdit() {
        if (!!this.custNo) {
            this.edit = (await this.datatask.Post(1539, { cust_no: this.custNo }))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.edit) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.edit.businessco_no });
    }

    public async createChanges() {
        if (!!this.edit) {
            try {
                this.creating = true;

                const response = (await this.datatask.Post(1540, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.creating = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'businessco_no':
                this.loadStockPlaces();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCompanies();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    cust_no: string;
    valid_for_all_stockplace: string;
    businessco_no: string;
    stockplace_id: string;
}
